import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpRequest} from "@angular/common/http";
import {Property} from "../model/property";
import {NgxIndexedDBService} from "ngx-indexed-db";

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private http: HttpClient, private indexDBService: NgxIndexedDBService) { }


  createPropertyHash(property: { street: string, zip: string, town: string, house_number?: string }): string {
    const { street, zip, town, house_number } = property;
    return `${street}_${zip}_${town}_${house_number || ''}`;
  }

  saveFile(file: File, propertyHash: string, type: string): void {
    const record = {
      file: file,
      propertyHash: propertyHash,
      type: type
    };

    this.indexDBService.add('authorities', record).subscribe();
  }

  uploadAuthorityMap(url: string, file: File, property:Property){

    const formData: FormData = new FormData();

    formData.append('file', file);
    formData.append('property', new Blob([JSON.stringify(property)],{type: "application/json"}));

    const req = new HttpRequest('POST', url, formData, {
      reportProgress: true,
      responseType: 'json',
      withCredentials: true
    });

    return this.http.request(req)

  }
}
